export enum ErrorType {
    Unauthorized = "Unauthorized",
    NoMatterPermission = "NoMatterPermission",
}